export const PROFILE_CERTIFICATIONS_SUCCESS = 'PROFILE_CERTIFICATIONS_SUCCESS';
export const PROFILE_CERTIFICATIONS_LOADING = 'PROFILE_CERTIFICATIONS_LOADING';
export const PROFILE_CERTIFICATIONS_ERROR = 'PROFILE_CERTIFICATIONS_ERROR';